export default __webpack_public_path__ + "pdfs/emotion.ae913c5c.pdf";